<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Open Account" />
            <AccountComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import AccountComp from '../Account/AccountComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'AccountPage',
    components: {
        NavBar,
        PageTitle,
        AccountComp,
        FooterComp,
    }
}
</script>